var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('Checkbox',{attrs:{"binary":true},model:{value:(_vm.localShowProfit),callback:function ($$v) {_vm.localShowProfit=$$v},expression:"localShowProfit"}}),_c('span',{staticClass:"px-2"},[_vm._v("$ Profit")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }